module.exports = __webpack_public_path__ + "img/gnzs25.51a4759e.png";